import LoadDetails from "./LoadDetails";

export default LoadDetails;